import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CommentCase, CommentFromSource } from '../interface/comment.interface';
import { EnvService } from 'src/app/services/env.service';

@Injectable({
  providedIn: 'root',
})
export class CaseCommentService {
  readonly baseUrl = `${this.env.URL_API_V1}/comment`;

  constructor(private readonly http: HttpClient, private env: EnvService) { }

  filterData = new Subject();

  createComment(caseRecord) {
    return this.http.post<CommentCase[]>(`${this.baseUrl}/create`, caseRecord);
  }

  getCommentsByCase(id) {
    return this.http.get<CommentCase[]>(`${this.baseUrl}/getAll/${id}`);
  }

  /**
   * Pasa un comentario de archivo a los comentarios del caso.
   * Es de una sola vía: el backend marca el original como enInforme.
   */
  createCommentFromSource(payload: CommentFromSource) {
    return this.http.post<CommentCase & { alreadySent?: boolean }>(
      `${this.baseUrl}/from-source`,
      payload,
    );
  }
}
